import { asHintId, type Hint } from '@/shared/stores';

import { DASHBOARD_PATIENT_RELATIONSHIP_ANCHOR } from '../anchors';

export const dashboardPatientRelationshipHint: Hint = {
  id: asHintId('dashboard:patient-relationship'),
  version: 1,
  priority: 55,
  anchor: DASHBOARD_PATIENT_RELATIONSHIP_ANCHOR,
  copy: {
    title: 'Who you can see',
    body: 'Actionable patients are eligible for you to open right now. Licensed means you are licensed in their state but cannot act yet; Outside license means they are out of your scope.',
    primaryLabel: 'Got it',
    secondaryLabel: 'Skip',
  },
};
